<div
  class="card-timer"
  *ngIf="component === 'SCREEN' || (currentTime$ | async)"
>
  <p *ngIf="label" [style.color]="color">{{ label }}:</p>

  <div class="icon-holder">
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
        <g id="button-top">
          <path
            fill="none"
            [style.stroke]="color"
            stroke="#222"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="16"
            d="M128 8v29"
          />
          <path
            fill="none"
            [style.stroke]="color"
            stroke="#222"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="16"
            d="M112 8h32"
          />
        </g>
        <circle
          [style.stroke]="color"
          cx="128"
          cy="143"
          r="105"
          fill="transparent"
          stroke="#222"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="16"
        />
        <path
          [style.stroke]="color"
          id="big-hand"
          fill="none"
          stroke="#222"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="16"
          d="M128 72v71"
        />
      </svg>
    </div>
  </div>

  <div class="hour-time" *ngIf="finish_date">
    <p [style.color]="color">
      {{ currentTime$ | async | secondsToHours : full_team }}
    </p>
  </div>
</div>
